// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2SCii","unreadBadge":"styles_unreadBadge__2e3nn","modalContent":"styles_modalContent__WwEtq","modal":"styles_modal__2l6qj"};